// Card #1798 AC8 — the postMessage contract between the public board
// (ScoreboardPage.jsx, the sender) and the remote control's live preview
// (RemotePage.jsx, the listener). RemotePage embeds the REAL board in an
// iframe of its own public route (same origin, no `sandbox` attribute) so
// the operator sees exactly what the board shows; this channel is how that
// same iframe also tells the operator WHY, something the board itself is
// never allowed to print (card #1798's whole rule).
//
// Superseded design (removed by this card, see the judge's note on commit
// 6e8075b1): RemotePage used to run its OWN independent
// useScoreboardPoll/fetchScoreboard poll plus a hidden `display:none`
// ScoreboardContent+ScoreboardErrorBoundary instance to guess the board's
// status from the same payload. That was an INEXACT replica — no
// VenueTimeZoneProvider, no SponsorStrip, no QRCorner — so it could pass
// when the real board would throw, or vice versa. Reading the real board's
// own reported status closes that gap instead of approximating it.
export const SCOREBOARD_STATUS_MESSAGE_TYPE = "fv-scoreboard-status";

// Every status the board can report. Mirrors BOARD_RENDER_REASON
// (boardRenderState.js) for the "blank" cases, plus the two failure modes
// only the board itself can observe directly: a poll/network fault (the
// remote's own poll can't see this either, once this channel replaces it)
// and a render exception (only ScoreboardErrorBoundary's onRenderStatus
// sees this, from inside the real render tree).
export const SCOREBOARD_STATUS = {
  OK: "ok",
  BLANK_UNKNOWN_MODE: "blank-unknown-mode",
  BLANK_NO_ACTIVE_CLASS: "blank-no-active-class",
  POLL_ERROR: "poll-error",
  RENDER_ERROR: "render-error",
};

// `detail` carries the one piece of operator-actionable text this card's
// AC8/#1777 exists for: the thrown Error's own `.message` (e.g.
// `fetchScoreboard`'s "scoreboard request failed (404)"), never a single
// generic string collapsing every fault into "can't reach the API".
export function postScoreboardStatus(status, detail = null) {
  if (typeof window === "undefined" || window.parent === window) return;
  window.parent.postMessage(
    { type: SCOREBOARD_STATUS_MESSAGE_TYPE, status, detail },
    window.location.origin
  );
}
